import React from "react";
import { CheckCircle } from "lucide-react";
import { Product } from "../../../../types/modules/product.type";

type ProductBoxProps = {
  product: Product;
  isSelected: boolean;
  onSelect: (prod: { id: number}) => void;
  onRemove: (id: number) => void;
};

const ProductBox: React.FC<ProductBoxProps> = ({ product, isSelected, onSelect, onRemove }) => {
  const handleClick = () => {
    if (isSelected) {
      onRemove(product.id);
    } else {
      onSelect({id:product.id});
    }
  };

  return (
    <div
      className={`flex justify-between items-center p-3  rounded-2xl cursor-pointer ${
        isSelected ? "bg-white text-primaryButton border-primaryButton border" : " bg-LightGrey1 text-DarkGrey3"
      }`}
      onClick={handleClick}
    >
      {/* Left side */}
      <div className="flex gap-3">
        {/* Image div */}
        <img 
        className=" w-[94px] h-[76px] rounded-2xl"
        src={product.images[0]} alt="" />
        {/* Info div */}
        <div className="flex flex-col justify-between">
          <span className="font-semibold">{product.languages[0].name}</span>
          <span className="text-sm ">{product.category.languages[0].title}</span>
          <span className="text-sm flex items-center gap-1"><img src={isSelected?"/vector.png":"/vector2.png"} className="w-[10.67px] h-[11.95px]" alt=""/>{product.basePrice}</span>
        </div>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-2">
        <span className="text-sm"># {product.productNumber}</span>
        <CheckCircle />
      </div>
    </div>
  );
};

export default ProductBox;
